import {getPublicProperty} from '@netx/core-app-next/utils';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	ShareMediaServicesPref,
	SHARE_MEDIA_SERVICE_SERVICES_MINIMUM_USER_LEVEL,
} from './constants';

export const canMangeMediaServiceServices = () =>
	currentUserMeetsUserLevel(SHARE_MEDIA_SERVICE_SERVICES_MINIMUM_USER_LEVEL);

/** are media services available */
export const mediaServicesAvailable = () =>
	getPublicProperty(ShareMediaServicesPref.ENABLED, true);

export const mediaServicesAuthenticated = () => {
	return (
		mediaServiceIsAuthenticated('Brightcove') ||
		mediaServiceIsAuthenticated('YouTube')
	);
};

export const mediaServiceIsAuthenticated = (mediaServiceName: string) => {
	// @ts-ignore
	const mediaServices = (Netx as any).share.mediaServices;
	const mediaService = mediaServices?.find({name: mediaServiceName});
	return mediaService?.get('authenticated') === true;
};
